export const ROUTES = {
    RETAILER_PROFILE: "retailer-profile",
};
